import { Store, VueStore } from "@mgs/ci2019-common/src/store";

@Store
export class ModulesState extends VueStore {
  modulesToCopy: number[] = [];

  toggleModuleToCopy(id: number) {
    const index = this.modulesToCopy.findIndex((_id) => _id === id);
    if (index === -1) this.modulesToCopy.push(id);
    else this.modulesToCopy.splice(index, 1);
  }
}
